import React from 'react';
import FormToastMessage from "./FormToastMessage";
export class DataHandler extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            ErrorMessage: ''
        }
        this.collectData = this.collectData.bind(this);
        this.collectMultiSelectData = this.collectMultiSelectData.bind(this);
        this.handleFormValidation = this.handleFormValidation.bind(this);
        this.trackInput = this.trackInput.bind(this);
    }

    handleFormValidation(){
        let formIsValid = true;
        let firstInvalidField = null;
        let tmpData = this.state.data.map((formArea) => {
            formArea.Fields.map((field) => {
                if(field.Required){
                    let fieldIsValid = true;
                    switch (field.Type){
                        case 'Upload': {
                            if(field.Value.length === 0){
                                fieldIsValid = false;
                            }
                            break;
                        }
                        case 'Dropdown':
                        case 'DateSelect':
                        case 'MultiSelect':
                        case 'Text': {
                            if(field.Value === ''){
                                fieldIsValid = false;
                            }
                            break;
                        }
                        case 'Email': {
                            if(field.Value === '' || !this.validateEmail(field.Value)){
                                fieldIsValid = false;
                            }
                            break;
                        }
                        case 'MultipleItems': {
                            if(field.Items.length === 0){
                                fieldIsValid = false;
                            }
                            break;
                        }
                        case 'TagField': {
                            if(!this.validateTagField(field)){
                                fieldIsValid = false;
                            }
                            break;
                        }
                        case 'Checkbox': {
                            if(!field.Value === true){
                                fieldIsValid = false;
                            }
                            break;
                        }
                        case 'Recaptcha': {
                            if(!field.Value === true){
                                fieldIsValid = false;
                            }
                            break;
                        }
                    }
                    field.IsValid = fieldIsValid;
                    if(!fieldIsValid){
                        if(firstInvalidField === null){
                            firstInvalidField = field;
                        }
                        formIsValid = false;
                    }
                }
                return field;
            })
            return formArea;
        })
        if(formIsValid){
            this.sendForm()
        } else {
            this.setState({
                data: tmpData,
            })
            let targetID = firstInvalidField.Key;
            let header = document.querySelector('header');
            let headerHeight = header.clientHeight;
            window.scrollTo({top:document.getElementById(targetID).offsetTop - headerHeight,behavior:'smooth'})
        }
    }

    formType(){
        return '';
    };

    sendForm(){
        let totalData = {
            'jobs': this.state.jobs,
            'locations': this.state.locations,
            'data': this.state.data,
            'ValidationHash': this.props.ValidationHash,
            'SessionID': this.props.SessionID,
            'FormType': this.formType()
        }

        fetch(this.props.handleForm, {
            method: 'POST',
            body: JSON.stringify(totalData),
        }).then(response =>  response.json()).
        then(json => {
            if(json.Error == "")
            {
                window.location.replace(this.state.RedirectURL);
            }
            else
            {
                //handle error display
                this.setState({
                    ErrorMessage: json.Error,
                })
                setTimeout(() => {
                    this.setState({
                        ErrorMessage: '',
                    })
                }, 5000)
            }
        })
    }

    renderToastMessage(){
        if(this.state.ErrorMessage === '' || this.state.ErrorMessage === undefined || this.state.ErrorMessage === null){
            return null;
        }
        return(
            <FormToastMessage Message={this.state.ErrorMessage}/>
        )
    }

    validateEmail(mail)
    {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
    }

    validateTagField(field){
        let fieldIsValid = false;
        field.Items.forEach((item) => {
            if(item.Selected){
                fieldIsValid = true;
            }
        })
        return fieldIsValid;
    }

    collectData(areakey, fieldkey, data){
        let tmpState = this.state.data.map((area) => {
            if(area.Key === areakey){
                area.Fields = area.Fields.map((field) => {
                    if (field.Key === fieldkey) {
                        let valueType = field.ValueType;
                        switch (valueType) {
                            case "Value": {
                                field.Value = data;
                                return field;
                            }
                            case "Items": {
                                switch (data.action) {
                                    case "add": {
                                        if(data.dataType === 'file'){
                                            if(field.AllowMultipleFiles){
                                                field.Value.push(data);
                                            } else {
                                                field.Value = [data];
                                            }
                                        } else if(data.dataType === 'fields'){
                                            field.Items = data.Fields.map(x => x);
                                        } else if(data.dataType === 'item'){
                                            field.Items.push(data);
                                        }
                                        break;
                                    }
                                    case "edit": {
                                        let items = field.Items;
                                        field.Items = items.map((item) => {
                                            if (item.ID === data.ID) {
                                                return data;
                                            }
                                            return item;
                                        })
                                        break;
                                    }
                                    case "delete": {
                                        if(data.dataType === 'file'){
                                            let items = field.Value;
                                            field.Value = items.filter(x => {
                                                return x.ID !== data.ID;
                                            })
                                            console.log(field.Value);
                                        } else if(data.dataType === 'fields' || data.dataType === 'item'){
                                            let items = field.Items;
                                            field.Items = items.filter(x => {
                                                return x.ID !== data.ID;
                                            })
                                        }
                                        break;
                                    }
                                }
                                return field;
                            }
                        }
                    } else {
                        return field;
                    }
                });
                return area;
            } else {
                return area;
            }
        })
        this.setState({
            data: tmpState,
        })
    }

    trackInput(areakey, fieldkey, formType = null){
        fetch(this.props.trackInputLink, {
            method: 'POST',
            body: JSON.stringify({
                'FieldKey': fieldkey,
                'AreaKey': areakey,
                'SessionID': this.props.SessionID,
                'FormType': formType,
            }),
        })
    }

    trackSubmit(){
        fetch(this.props.trackSubmitLink, {
            method: 'POST',
            body: JSON.stringify({
                'SessionID': this.props.SessionID,
            }),
        })
    }

    collectMultiSelectData(state, key, data){
        var array = state;
        array.forEach(item => {
            if(key === item.ID){
                item.Selected = data;
            }
        })
        this.setState({
            state: array,
        })
    }
}
export default DataHandler;
